<template>
    <v-row class="mb-15 fill-height">
        <v-col>
            <v-row>
                <v-col>
                    <h1>Reporte de Retenciones</h1>
                </v-col>
            </v-row>
            <v-row style="padding-left: 30px; margin-top: 25px">
                <v-select label="Tipo de Servicio" outlined style="max-width: 420px" class="mt-5" :items="tiposServicio"
                    v-model="tipoServicio" v-show="canShow" /> </v-row>
            <v-row class="mb-15" style="padding-left: 30px">
                <v-col md="3">
                    <h3>Selecciona el rango de fechas</h3>
                    <v-date-picker style="width: 100%" v-model="dates" :min="minDate" :max="maxDate"
                        range></v-date-picker>
                    <v-btn rounded color="primary mt-4" style="width: 100%" dark @click="consultar()"
                        :disabled="blockBoton">Consultar</v-btn>
                    <v-btn rounded color="primary" style="width:100%;margin-top:20px;" :disabled="bloquear"
                        @click="downloadFile()">
                        Descargar Información
                    </v-btn>
                </v-col>
                <v-col cols="9" md="9">
                    <div>
                        <div v-if="loading" style="text-align: center">
                            <h2 clas="pb-4">Cargando Reporte....</h2>
                            <br /><br />
                            <v-progress-circular :size="100" :width="10" color="primary"
                                indeterminate></v-progress-circular>
                        </div>
                    </div>

                    <v-data-table :headers="columns" :items="retenciones" class="elevation-1"
                        :server-items-length="totalRegistros" :loading="loading" loading-text="Cargando..."
                        :items-per-page="elementosPagina" @update:page="pagina = $event"
                        @update:items-per-page="elementosPagina = $event">
                    </v-data-table>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
var moment = require("moment-timezone");
import download from "downloadjs";
import { getReporteRetenciones, getReporteRetencionesForDownload } from "@/services/reporteService";
import { ListExpanded } from "../../../../plugins/mixins";

export default {
    mixins: [ListExpanded],

    data() {
        return {
            dates: ["", ""],
            roles: JSON.parse(localStorage.getItem("roles")),
            agenteUuid: localStorage.getItem("agenteUuid"),
            loading: false,
            retenciones: [],
            retencionesDownload: [],
            bloquear: true,
            tiposServicio: ["Ambos", "Asistencias", "Seguros"],
            tipoServicio: "Ambos",

            columns: [
                { text: "No. Solicitud", value: "id" },
                { text: "Fecha de Solicitud", value: "fechaSolicitud" },
                { text: "Titulo", value: "titulo" },
                { text: "Status", value: "statusSolicitud" },
                { text: "Tipo de Servicio", value: "tipoServicio" },
                { text: "Motivo Retención", value: "motivoRetencion" }
            ],
            pagina: 1,
            elementosPagina: 10,
            totalRegistros: 0,
        };
    },

    watch: {
        pagina(v) {
            !!v && this.consultar();
        },

        elementosPagina(v) {
            !!v && this.consultar();
        },
    },

    methods: {
        async consultar() {
            try {
                this.loading = true;
                this.bloquear = true;
                var inicioUTC = null;
                var finUTC = null;

                if (this.dates.length > 0) {
                    if (this.dates[1]) {
                        inicioUTC = moment
                            .utc(this.dates[0])
                            .add(6, "hours")
                            .format("YYYY-MM-DD HH:mm:ss");
                        finUTC = moment
                            .utc(this.dates[1])
                            .add(6, "hours")
                            .add(24, "hours")
                            .subtract(1, "seconds")
                            .format("YYYY-MM-DD HH:mm:ss");
                    } else {
                        inicioUTC = moment.utc(this.dates[0]).format("YYYY-MM-DD HH:mm:ss");
                        finUTC = moment
                            .utc(this.dates[0])
                            .add(24, "hours")
                            .add(6, "hours")
                            .subtract(1, "seconds")
                            .format("YYYY-MM-DD HH:mm:ss");
                    }
                }

                let query = {
                    fechas: [inicioUTC, finUTC],
                    tipoServicio: this.tipoServicio,
                    elementosPagina: this.elementosPagina,
                    pagina: this.pagina,
                };

                let response = await getReporteRetenciones(query);
                this.retenciones = response.data;
                this.totalRegistros = response.count;
            } finally {
                this.loading = false;
                this.bloquear = false;
            }
        },

        async downloadFile() {
            try {
                this.loading = true;
                this.bloquear = true;
                var inicioUTC = null;
                var finUTC = null;

                if (this.dates.length > 0) {
                    if (this.dates[1]) {
                        inicioUTC = moment
                            .utc(this.dates[0])
                            .add(6, "hours")
                            .format("YYYY-MM-DD HH:mm:ss");
                        finUTC = moment
                            .utc(this.dates[1])
                            .add(6, "hours")
                            .add(24, "hours")
                            .subtract(1, "seconds")
                            .format("YYYY-MM-DD HH:mm:ss");
                    } else {
                        inicioUTC = moment.utc(this.dates[0]).format("YYYY-MM-DD HH:mm:ss");
                        finUTC = moment
                            .utc(this.dates[0])
                            .add(24, "hours")
                            .add(6, "hours")
                            .subtract(1, "seconds")
                            .format("YYYY-MM-DD HH:mm:ss");
                    }
                }

                let query = {
                    fechas: [inicioUTC, finUTC],
                    tipoServicio: this.tipoServicio,
                };
                let response = await getReporteRetencionesForDownload(query);
                this.retencionesDownload = response.data;
                download(this.retencionesDownload, `Informe_retenciones.csv`, "application/csv");
            } finally {
                this.loading = false;
                this.bloquear = false;
            }

        },
    },
    computed: {
        blockBoton() {
            return !(this.tipoServicio != null && this.fechasValidas && this.loading == false);
        },
        fechasValidas() {
            return Array.isArray(this.dates) &&
                this.dates.length === 2 &&
                this.dates.every(d => d !== null && d !== undefined && d !== "");
        },
        canShow() {
            var canView = false;
            var roles = [];
            this.roles.forEach((element) => {
                roles.push(element.rol);
            });
            const rolesToView = ["ADMIN", "DIRECTOR", "FINANZAS"];
            roles.forEach((element) => {
                if (rolesToView.includes(element)) {
                    canView = true;
                }
            });
            return canView;
        },
        currentRol() {
            let roles = [];
            this.roles.forEach((element) => {
                if (element.rol != null) {
                    roles.push(element.rol);
                }
            });

            if (roles.length > 0) {
                return roles[0];
            } else {
                return "";
            }
        },
        minDate() {
            return this.dates.length === 1 ? this.dates[0] : null;
        },
        maxDate() {
            if (this.dates.length !== 1) return null;
            const d = new Date(this.dates[0]);
            d.setMonth(d.getMonth() + 1);
            return d.toISOString().substr(0, 10);
        },
    },
};
</script>
